module.exports = __webpack_public_path__ + "media/6.20330aec.wav";